import template from './complaintCorpCommentsModal.html';
import controller from './complaintCorpCommentsModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    corpComments: '<',
  },
};
